module.exports = __webpack_public_path__ + "img/totalQues.16714faf.svg";